export const SignalHot = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="10" height="12" viewBox="0 0 10 12" fill="none">
    <path
      d="M9.33268 7.33333C9.33268 9.66666 7.57668 11.6667 4.99935 11.6667C2.42202 11.6667 0.666016 9.66666 0.666016 7.33333C0.666016 6.13889 1.33268 4.33333 2.99935 3.33333C2.99935 5.33333 2.99935 7.2 4.33268 6.66667C6.13446 5.94596 2.33268 2.66667 4.99935 0C6.33268 4.33333 9.33268 4 9.33268 7.33333Z"
      fill="#261B36"
    />
  </svg>
);
